import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('store')

import Utils from "@/helpers/utils.js";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    preview: false,
    preview_date: '',
    banners: [],
    channels: [],
    cables: [],
    schedules: [],
    boards: {
      list: [],
      totalPage: 0
    },
  },
  mutations: {
    setPreviewDate(state, data) {
      state.preview = _.size(data) > 0
      state.preview_date = data
    },
    setBanners(state, data) {
      try {
        state.banners = Utils.sortData(
          _.forEach(data, v => {
            v['content'] = v['content'].replace(/(?:\r\n|\r|\n)/g, '<BR/>')
            v['sub_title'] = v['sub_title'].replace(/(?:\r\n|\r|\n)/g, '<BR/>')
          })
        )
      } catch (e) {
        state.banners = []
      }
    },
    setChannels(state, data) { state.channels = Utils.sortData(data) },
    setCables(state, data) { state.cables = data },
    setSchedules(state, data) { state.schedules = data },
    setBoards(state, data) {
      let temp = _.map(data.data, (v) => { 
        v['expand'] = false //내용 확장 플래그
        v['images'] = [] // 이미지 배열
        v['files'] = []  // 파일 배열
        v['content'] = v['content'].replace(/(?:\r\n|\r|\n)/g, '<BR/>')
        v['images'] = _.concat([v['img_url1'], v['img_url2'], v['img_url3']].filter(v => !_.isNil(v) && !_.isEmpty(v)))
        v['files'] = _.concat([v['file1'], v['file2'], v['file3']].filter(v => !_.isNil(v) && !_.isEmpty(v)))
        
        return v
      })

      //상단고정
      let filtered = _.filter(temp, {'top_fix': true})
      _.forEach(filtered, (v) => {
        let index = _.findIndex(temp, {'id': v.id})
        temp.splice(index, 1)
        temp.unshift(v)
      })
      state.boards.list = temp
      state.boards.totalPage = Math.ceil(data.totalCount/10)
    },
  },
  actions: {
    async getBanners({commit}) {
      try {
        const response = await api.get('banner/list')
        console.log("banners :", response.data)
        commit('setBanners', response.data)
      } catch (e) {
        console.error('[axios] getBanners :', e.message)
      }
    },
    async getChannels({commit}) {
      try {
        const response = await api.get('channel/list')
        console.log("channels :", response.data)
        commit('setChannels', response.data)
      } catch (e) {
        console.error('[axios] getChannels :', e.message)
      }
    },
    async getCables({commit}) {
      try {
        const response = await api.get('cable/list')
        console.log("cables :", response.data)
        commit('setCables', response.data)
      } catch (e) {
        console.error('[axios] getCables :', e.message)
      }
    },
    async getSchedules({state, commit}, date) {
      try {
        let req_url = `schedule/${date}`
        const response = await api.get(req_url)
        console.log("getSchedules :", response.data)
        commit('setSchedules', response.data)
        return response.data
      } catch (e) {
        console.error('[axios] getSchedules :', e.message)
      }
    },
    async getSchedulesRange({state, commit}, {start_date, end_date}) {
      try {
        let req_url = `schedule/range?start_date=${date}&end_date='${end_date}`;
        const response = await api.get(req_url)
        console.log("getSchedulesRange :", response.data)
        commit('setSchedules', response.data)
        return response.data
      } catch (e) {
        console.error('[axios] getSchedules :', e.message)
      }
    },
    async getBoards({commit}, currentPage) {
      try {
        const response = await api.get(`board?page=${currentPage}`)
        console.log("boards :", response.data)
        commit('setBoards', response.data)
      } catch (e) {
        console.error('[axios] getBoards :', e.message)
      }
    },
  }
}